const getDefaultState = () => {
  return {
    appsForClients: {},
  }
}

const state = getDefaultState()
const getters = {
  /* https://vuex.vuejs.org/guide/getters.html#property-style-access */
  getFilteredAppForClient: state => clientHash => {
    return state.appsForClients[clientHash];
  }
};

const mutations = {
  SET_FILTERED_APP_FOR_CLIENT: (state, payload) => {
    state.appsForClients[payload.clientHash] = payload.appHash;
  },
};

const actions = {
  setFilteredAppForClient: ({ commit }, payload) => {
    commit('SET_FILTERED_APP_FOR_CLIENT', payload);
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
};
